/**
 * Coups de pouce — Attendu 1129 « Compléter : 20 % de 120 = … ;
 * 30 = …/100 × 1 000 » (automatisme 4e).
 *
 * de_* (saisie, QCM), etapes_texte_trou et vf_tableau_vf : entrée PARTAGÉE —
 * partir de 10 %, multiplier ou partager, ou a ÷ 100 × c, contrôler. L'exemple
 * (revue 2026-09-08) : 30 % de 240 sur une bande en 10 parts, 24 puis 72,
 * pièges 240 − 30 et 30 × 240. SVG piloté par les flèches de la sheet
 * (data-etapes / data-caption).
 *
 * rappel_tableau_vf : pur rappel, pas d'entrée (doctrine 2026-07-31).
 */

// Bande de 240 partagée en 10 parts de 24 : x de 30 à 330
const X0 = 30; const LB = 300; const PART = LB / 10;
const cases = (y, colorees, couleur) => [...Array(10).keys()].map((k) => `<rect x="${(X0 + k * PART).toFixed(1)}" y="${y}" width="${(PART - 1).toFixed(1)}" height="18" fill="${k < colorees ? couleur : '#E2E8F0'}" stroke="#94A3B8" stroke-width="0.8" rx="2"/>`
    + `<text x="${(X0 + k * PART + PART / 2).toFixed(1)}" y="${y + 13}" font-size="9.5" font-weight="700" fill="${k < colorees ? '#ffffff' : '#475569'}" text-anchor="middle">24</text>`).join('');

const SVG_DE = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 300" width="100%" style="max-width:380px;height:auto;display:block" role="img" data-etapes="3"
     aria-label="Compléter 30 pour cent de 240, en 3 étapes à faire défiler avec les flèches. Une bande représente 240, partagée en 10 parts de 24. Étape 1 : 10 pour cent de 240, c'est 240 divisé par 10, soit 24, une part. Étape 2 : 30 pour cent, c'est 3 fois 10 pour cent, donc 3 fois 24 égale 72, trois parts. Étape 3 : contrôle, 72 est plus petit que 240 ; pièges : 240 moins 30 égale 210 est faux, 30 fois 240 égale 7 200 est faux. Réponse : 30 pour cent de 240 égale 72">
  <style>
    @keyframes cp1129-pop { from { opacity: 0; } to { opacity: 1; } }
    .cp1129-pop { opacity: 0; animation: cp1129-pop 0.5s ease forwards; }
  </style>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#1E3A8A" opacity="1" data-caption="1" font-family="system-ui,sans-serif">Complète : 30 % de 240 = …</text>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#1D9E75" opacity="0" data-caption="2" font-family="system-ui,sans-serif">30 %, c'est 3 fois 10 %</text>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#B45309" opacity="0" data-caption="3" font-family="system-ui,sans-serif">On contrôle, et on évite deux pièges</text>

  <!-- ── 10 % : une part sur dix (étape 1) ───────────────────────────────── -->
  <g data-etape="1" font-family="system-ui,sans-serif">
    <text x="8" y="46" font-size="11" font-weight="700" fill="#1e293b">Le nombre 240, partagé en 10 parts égales :</text>
    ${cases(54, 1, '#1E3A8A')}
    <text x="8" y="96" font-size="11.5" font-weight="700" fill="#1E3A8A">10 % de 240 = 240 ÷ 10 = 24  (une part)</text>
  </g>

  <!-- ── 30 % : trois parts (étape 2) ────────────────────────────────────── -->
  <g data-etape="2" data-anim="1" font-family="system-ui,sans-serif">
    <g class="cp1129-pop">
      ${cases(112, 3, '#1D9E75')}
      <text x="8" y="154" font-size="11.5" font-weight="700" fill="#1D9E75">30 % de 240 = 3 × 24 = 72  (trois parts) ✓</text>
      <text x="8" y="170" font-size="10" font-weight="600" fill="#1D9E75">autre chemin : 30 ÷ 100 = 0,3 et 0,3 × 240 = 72</text>
    </g>
  </g>

  <!-- ── Contrôle et pièges (étape 3) ────────────────────────────────────── -->
  <g data-etape="3" data-anim="1" font-family="system-ui,sans-serif">
    <g class="cp1129-pop">
      <text x="8" y="202" font-size="11.5" font-weight="700" fill="#B45309">72 est bien plus petit que 240 ✓</text>
      <text x="8" y="220" font-size="11" font-weight="700" fill="#DC2626">240 − 30 = 210 ✗  un pourcentage ne se soustrait pas</text>
      <text x="8" y="236" font-size="11" font-weight="700" fill="#DC2626">30 × 240 = 7 200 ✗  il manque le ÷ 100</text>
      <text x="8" y="266" font-size="11.5" font-weight="700" fill="#1e293b">Réponse : 30 % de 240 = 72.</text>
    </g>
  </g>

  <text x="180" y="292" font-size="11" font-weight="700" fill="#b45309" text-anchor="middle" opacity="0" data-caption="1" font-family="system-ui,sans-serif">↓ Touche les flèches pour avancer, étape par étape ↓</text>
</svg>`.trim();

const AIDE_DE = {
    pages: [
        {
            titre: 'La règle',
            lignes: [
                "**Pars de 10 %** : 10 % d'un nombre, c'est le nombre divisé par 10. C'est la brique de tous les autres pourcentages.",
                "**Puis multiplie ou partage** : 20 %, c'est 2 fois 10 % ; 30 %, 3 fois 10 % ; 5 %, la moitié de 10 % ; 15 %, 10 % plus 5 %.",
                "**L'autre chemin, si tu préfères** : a % de c, c'est a ÷ 100 × c. Pour 20 % de 120 : 20 ÷ 100 = 0,2 et 0,2 × 120 = 24.",
                "**Vérifie** : le résultat est plus petit que le nombre de départ, et 20 % de 120 n'est pas 120 − 20.",
            ],
        },
        { titre: 'Un exemple', svg: SVG_DE },
    ],
};

// ─── Compléter …/100 × c : 40 = …/100 × 500 ───────────────────────────────
/** Fraction dessinée : numérateur, barre, dénominateur, centrés en x ; la barre est à y. */
const FRAC = (x, y, n, d, taille, couleur, largeur) => `<text x="${x}" y="${y - 3}" font-size="${taille}" font-weight="700" fill="${couleur}" text-anchor="middle">${n}</text>`
    + `<line x1="${x - largeur / 2}" y1="${y}" x2="${x + largeur / 2}" y2="${y}" stroke="${couleur}" stroke-width="1.4"/>`
    + `<text x="${x}" y="${y + taille + 1}" font-size="${taille}" font-weight="700" fill="${couleur}" text-anchor="middle">${d}</text>`;

const SVG_ECRITURE = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 300" width="100%" style="max-width:380px;height:auto;display:block" role="img" data-etapes="3"
     aria-label="Compléter 40 égale point d'interrogation sur 100 fois 500, en 3 étapes à faire défiler avec les flèches. Étape 1 : l'égalité se lit 40, c'est un certain pourcentage de 500 ; le trou est un pourcentage. Étape 2 : on ramène à 100 ; 40 sur 500 égale point d'interrogation sur 100 ; une flèche va de 500 à 100 avec divisé par 5, une flèche va de 40 au point d'interrogation avec divisé par 5 ; 40 divisé par 5 égale 8. Étape 3 : vérification, 8 sur 100 fois 500 égale 4 000 sur 100 égale 40 ; on remet le nombre trouvé dans le calcul de départ. Réponse : le trou vaut 8,40 égale 8 sur 100 fois 500">
  <style>
    @keyframes cp1129-pop { from { opacity: 0; } to { opacity: 1; } }
    .cp1129-pop { opacity: 0; animation: cp1129-pop 0.5s ease forwards; }
  </style>
  <defs>
    <marker id="cp1129-fleche" viewBox="0 0 10 10" refX="8" refY="5" markerWidth="7" markerHeight="7" orient="auto-start-reverse">
      <path d="M 0 0 L 10 5 L 0 10 z" fill="#1D9E75"/>
    </marker>
  </defs>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#1E3A8A" opacity="1" data-caption="1" font-family="system-ui,sans-serif">Complète : 40 = …/100 × 500</text>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#1D9E75" opacity="0" data-caption="2" font-family="system-ui,sans-serif">On ramène 500 à 100</text>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#B45309" opacity="0" data-caption="3" font-family="system-ui,sans-serif">On vérifie, et on évite deux pièges</text>

  <!-- ── Lire l'égalité (étape 1) ────────────────────────────────────────── -->
  <g data-etape="1" font-family="system-ui,sans-serif">
    <text x="8" y="48" font-size="11.5" font-weight="700" fill="#1E3A8A">L'égalité se lit : « 40, c'est … % de 500 ».</text>
    <text x="8" y="66" font-size="10" font-weight="600" fill="#475569">Le nombre du trou est un pourcentage : 40 sur 500, c'est combien sur 100 ?</text>
  </g>

  <!-- ── Ramener à 100 (étape 2) ─────────────────────────────────────────── -->
  <g data-etape="2" data-anim="1" font-family="system-ui,sans-serif">
    <g class="cp1129-pop">
      ${FRAC(60, 124, '40', '500', 13, '#1D9E75', 30)}
      <text x="98" y="129" font-size="14" font-weight="800" fill="#1D9E75" text-anchor="middle">=</text>
      ${FRAC(138, 124, '?', '100', 13, '#1D9E75', 30)}
      <path d="M 72 109 Q 99 97 124 109" fill="none" stroke="#1D9E75" stroke-width="1.8" marker-end="url(#cp1129-fleche)"/>
      <text x="99" y="102" font-size="11" font-weight="800" fill="#DC2626" text-anchor="middle">÷ 5</text>
      <path d="M 72 142 Q 99 156 124 142" fill="none" stroke="#1D9E75" stroke-width="1.8" marker-end="url(#cp1129-fleche)"/>
      <text x="99" y="161" font-size="11" font-weight="800" fill="#DC2626" text-anchor="middle">÷ 5</text>
      <text x="184" y="112" font-size="11.5" font-weight="700" fill="#1D9E75">500 <tspan fill="#DC2626">÷ 5</tspan> = 100</text>
      <text x="184" y="130" font-size="11.5" font-weight="700" fill="#1D9E75">donc 40 <tspan fill="#DC2626">÷ 5</tspan> = 8</text>
      <text x="184" y="150" font-size="12" font-weight="800" fill="#1D9E75">40 sur 500 = 8 sur 100 ✓</text>
    </g>
  </g>

  <!-- ── Vérification (étape 3) ──────────────────────────────────────────── -->
  <g data-etape="3" data-anim="1" font-family="system-ui,sans-serif">
    <g class="cp1129-pop">
      <text x="8" y="196" font-size="11.5" font-weight="700" fill="#B45309">Vérification : 8/100 × 500 = 4 000/100 = 40 ✓</text>
      <text x="8" y="214" font-size="10.5" font-weight="600" fill="#B45309">on remet le nombre trouvé dans le calcul de départ</text>
      <text x="8" y="242" font-size="11.5" font-weight="700" fill="#1e293b">Réponse : le trou vaut 8, car 40 = 8/100 × 500.</text>
    </g>
  </g>

  <text x="180" y="292" font-size="11" font-weight="700" fill="#b45309" text-anchor="middle" opacity="0" data-caption="1" font-family="system-ui,sans-serif">↓ Touche les flèches pour avancer, étape par étape ↓</text>
</svg>`.trim();

const AIDE_ECRITURE = {
    pages: [
        {
            titre: 'La règle',
            lignes: [
                "**Lis l'égalité comme une phrase** : « 30 = …/100 × 1 000 » veut dire « 30, c'est … % de 1 000 ». Le nombre du trou est un pourcentage.",
                "**Ramène à 100** : 30 sur 1 000, c'est combien sur 100 ? De 1 000 à 100 on divise par 10, donc 30 ÷ 10 = 3. Le trou vaut 3.",
                "**Si c'est le nombre de départ qui manque** (« 30 = 3/100 × … »), fais le chemin inverse : 3 sur 100, c'est 30 sur combien ? De 3 à 30 on multiplie par 10, donc 100 × 10 = 1 000.",
                "**Vérifie en calculant** : 3/100 × 1 000 = 3 000/100 = 30. Attention, le trou n'est ni 30 (recopié) ni 300.",
            ],
        },
        { titre: 'Un exemple', svg: SVG_ECRITURE },
    ],
};

const CP_1129 = {
    de_saisie: AIDE_DE,
    de_qcm_unique: AIDE_DE,
    etapes_texte_trou: AIDE_DE,
    ecriture_saisie: AIDE_ECRITURE,
    ecriture_qcm_unique: AIDE_ECRITURE,
    vf_tableau_vf: AIDE_DE,
};

export default CP_1129;
